<template>
  <div class="mask" v-if="visible" @click.self="closeView">
    <div class="dialog">

      <!-- 右上角关闭按钮 -->
      <div class="close-btn" @click="closeView">×</div>

      <!-- 标题 -->
      <div class="title">
        重要通知
      </div>

      <!-- 正文 -->
      <div class="content">
        <p class="greet">尊敬的用户：</p>

        <p>
          近期部分用户反馈无法正常接收服务器短信验证码，导致登录及业务操作受阻。 该问题由短信签名策略调整及运营商网关限制引发，技术团队已紧急处置。
        </p>

        <p>
          感谢您的理解与支持！我们将尽快优化服务，携手共建稳定可靠的业务环境！
        </p>
      </div>

      <!-- 落款 -->
      <div class="foot">
        <span>中国煤炭工业协会</span>
        <span>2026年3月13日</span>
      </div>

    </div>
  </div>
</template>

<script>
export default {

  props: ["json"],

  data() {
    return {
      visible: true
    };
  },

  mounted() {

    // 监听ESC关闭
    window.addEventListener("keydown", this.keyClose)

    // ===== 防止页面抖动 =====
    const scrollBarWidth =
      window.innerWidth - document.documentElement.clientWidth

    document.body.style.overflow = "hidden"

    if (scrollBarWidth > 0) {
      document.body.style.paddingRight = scrollBarWidth + "px"
    }

  },

  beforeUnmount() {

    window.removeEventListener("keydown", this.keyClose)

    document.body.style.overflow = ""
    document.body.style.paddingRight = ""

  },

  methods: {

    // 关闭公告
    closeView() {

      this.visible = false

      document.body.style.overflow = ""
      document.body.style.paddingRight = ""

      this.$emit("closeViewAn")

    },

    // ESC关闭
    keyClose(e) {

      if (e.key === "Escape") {
        this.closeView()
      }

    }

  }

};
</script>

<style scoped>
/* 遮罩 */
.mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);

  display: flex;
  align-items: center;
  justify-content: center;

  z-index: 9999;
  animation: fadeIn 0.3s;
}

/* 弹窗主体 */
.dialog {
  width: 460px;
  background: #fff;
  border-radius: 6px;
  padding: 30px 40px;
  position: relative;

  animation: dialogIn 0.35s;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
}

/* 标题 */
.title {
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
}

/* 内容 */
.content {
  font-size: 15px;
  line-height: 1.9;
  color: #333;
}

.content p {
  text-indent: 2em;
  margin: 10px 0;
}

.greet {
  text-indent: 0;
}

/* 落款 */
.foot {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  font-size: 14px;
}

/* 关闭按钮 */
.close-btn {
  position: absolute;
  right: 12px;
  top: 12px;

  width: 30px;
  height: 30px;
  line-height: 28px;

  text-align: center;
  font-size: 20px;

  color: #666;
  cursor: pointer;
  border-radius: 50%;

  transition: all 0.2s;
  z-index: 10;
}

.close-btn:hover {
  background: #f2f2f2;
  color: #333;
}

/* 动画 */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes dialogIn {
  from {
    transform: scale(0.85);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

/* 手机适配 */
@media (max-width: 768px) {
  .dialog {
    width: 90%;
    padding: 25px;
  }
}
</style>